import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Menu, Dropdown, Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { logout } from '../../auth/helpers';
import { useNavigate } from 'react-router-dom';
import { getConsultantProfileData } from '../../services/ConsultantService';

const LogoutDropdown = ({userDetails}) => {
  const dispatch = useDispatch();
  const getInitialPic = () => {
    let pic = userDetails?.profile_pic;
    if (!pic && userDetails?.user_role === 'um_trusted-dealer') {
      pic = userDetails?.profiles?.[0]?.logo_url || userDetails?.logo_url;
    } else if (!pic && userDetails?.user_role === 'um_flooring-consultant') {
      pic = userDetails?.profiles?.[0]?.profile_pic || userDetails?.profiles?.[0]?.photo_url;
    }
    return pic || null;
  };

  const [avatarPic, setAvatarPic] = useState(getInitialPic());
  let navigate = useNavigate();

  useEffect(() => {
    const pic = getInitialPic();
    if (pic) {
      setAvatarPic(pic);
    } else if (userDetails?.user_role === 'um_flooring-consultant') {
      const cId = userDetails?.consultant_profile_id || userDetails?.profiles?.[0]?.ID;
      if (cId) {
        dispatch(getConsultantProfileData(cId)).then((res) => {
          if (res && (res.profile_pic || res.photo_url)) {
            setAvatarPic(res.profile_pic || res.photo_url);
          }
        }).catch(() => {});
      }
    }
  }, [userDetails, dispatch]);
  const handleMenuClick = (e) => {
    if (e.key === 'account') {
      // Handle account option click
      window.location.replace('https://www.floordetective.com/membership-account/');
      console.log('Account clicked');
    } else if (e.key === 'updateProfile') {
      // Handle update profile option click
      navigate('/update-profile');
    } else if (e.key === 'logout') {
      // Handle logout option click
      logout();
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item title="account" key="account">Account</Menu.Item>
      <Menu.Item  key="updateProfile">Update Profile</Menu.Item>
      <Menu.Item title="logout" key="logout">Logout</Menu.Item>
    </Menu>
  );
  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <Avatar 
      icon={<UserOutlined />}
      src={avatarPic ? <img src={avatarPic} alt="avatar" /> : null}
      style={{ cursor: 'pointer',marginLeft: '15px' }}
      />
    </Dropdown>
  );
};

export default LogoutDropdown;
